<template>
  <div>
    <a-modal
      title="标签点位"
      :visible="visibleModal"
      wrapClassName="tag-ponit-modal"
      width="1000px"
      @cancel="pointsModalhandleCancel()"
    >
      <div class="row-btns">
        <a-button
          type="primary"
          style="margin-right: 8px;"
          @click="visibleAddPointsModal = true"
          >新 增</a-button
        >
        <a-button @click="visibleImportModal = true">导 入</a-button>
      </div>
      <a-table
        rowKey="id"
        :loading="pointTableLoading"
        :columns="pointTableColumns"
        :dataSource="pointList"
        :row-selection="{
          fixed: true,
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          onSelectAll: onPointSelectAll
        }"
        :scroll="{ x: 1200 }"
        :pagination="{
          pageSize: pointTablePageSize,
          showTotal: total => `共${total}条 `
        }"
      >
        <div
          slot="filterDropdown"
          slot-scope="{
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            column
          }"
          style="padding: 8px"
        >
          <a-input
            v-ant-ref="c => (searchInput = c)"
            :placeholder="`搜索${column.title}`"
            :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block;"
            @change="
              e => setSelectedKeys(e.target.value ? [e.target.value] : [])
            "
            @pressEnter="
              () => handleSearch(selectedKeys, confirm, column.dataIndex)
            "
          />
          <a-button
            type="primary"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
          >
            搜 索
          </a-button>
          <a-button
            size="small"
            style="width: 90px"
            @click="() => handleReset(clearFilters)"
          >
            重 置
          </a-button>
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered"
          type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
        <template slot="pointAction" slot-scope="text, record">
          <a-popconfirm
            placement="topRight"
            ok-text="确 定"
            cancel-text="取 消"
            @confirm="deletePointsApi([record.id])"
          >
            <template slot="title">
              <p>你确定要删除该点位吗？</p>
            </template>
            <a href="#">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
      <div v-if="pointList.length > 0" class="tag-point-table-bottom">
        <a-button @click="deletePointsConfirm">删除所选</a-button>
      </div>
      <template slot="footer">
        <a-button key="back" @click="pointsModalhandleCancel">
          关 闭
        </a-button>
      </template>
    </a-modal>
    <ExcelImport
      title="点位导入"
      :visible-modal.sync="visibleImportModal"
      :fileLength="1"
      :templateFileInfo="{
        fileUrl: `${baseURL}/importTemplate/QFAD-标签点位导入模板.xlsx`,
        desc: 'QFAD标签点位导入模板'
      }"
      :requestConfig="{
        url: '/tag/importTagPoints',
        params: { tagId: modalId }
      }"
      @successCallback="getPointList"
    ></ExcelImport>
    <!-- 标签对应点位操作穿梭框 -->
    <AddPoints
      v-if="visibleAddPointsModal"
      :visible-modal.sync="visibleAddPointsModal"
      :modalId="modalId"
      @reloadPointList="getPointList"
    ></AddPoints>
  </div>
</template>

<script>
import api from "../../commomFun/api.js";
import ExcelImport from "./common/excelImport.vue";
import AddPoints from "./common/addPoints.vue";
import { baseURL } from "../../utils/config";

export default {
  props: {
    visibleModal: Boolean,
    modalId: Number
  },
  components: {
    ExcelImport,
    AddPoints
  },
  data() {
    return {
      baseURL,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      pointList: [],
      pointTableLoading: false,
      pointTableColumns: [
        {
          title: "Mac",
          key: "devId",
          dataIndex: "devId",
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: text => text || "--",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) =>
            record.devId
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "点位名称",
          key: "deviceName",
          dataIndex: "deviceName",
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: text => text || "--",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) =>
            record.deviceName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "点位ID",
          key: "id",
          dataIndex: "id",
          width: 100,
          scopedSlots: {
            customRender: text => text || "--",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) =>
            record.id
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "终端型号",
          dataIndex: "version",
          key: "version",
          width: 120,
          scopedSlots: {
            customRender: text => text || "--",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) =>
            record.version
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "所属城市",
          dataIndex: "city",
          key: "city",
          width: 120,
          scopedSlots: {
            customRender: text => text || "--",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) =>
            record.city
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "区县",
          dataIndex: "area",
          key: "area",
          width: 120,
          scopedSlots: {
            customRender: text => text || "--",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) =>
            record.area
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "网点资源",
          key: "communityName",
          dataIndex: "communityName",
          ellipsis: true,
          width: 120,
          scopedSlots: {
            customRender: text => text || "--",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) =>
            record.communityName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "操作",
          dataIndex: "pointAction",
          key: "pointAction",
          align: "left",
          width: 80,
          fixed: "right",
          scopedSlots: {
            customRender: "pointAction"
          }
        }
      ],
      // 点位选择的行
      selectedRowKeys: [],
      // 点位分页
      pointTablePageSize: 10,
      // 新增点位弹窗 是否显示
      visibleAddPointsModal: false,
      // 导入点位
      visibleImportModal: false
    };
  },
  watch: {
    visibleModal(val) {
      if (val) {
        this.getPointList();
      }
    }
  },
  methods: {
    getPointList() {
      if (!this.modalId) {
        this.$message.warning("获取标签ID失败！");
        return;
      }
      this.pointTableLoading = true;
      this.pointList = [];
      this.selectedRowKeys = [];
      api
        .getApi(`/tag/getTagPointList`, {
          tagId: this.modalId,
          pageNum: 1,
          pageSize: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.pointList = res.data.data.list || [];
          } else {
            this.$message.warning(res.data.msg || "获取点位列表失败");
          }
        })
        .catch(e => {
          console.error("getPointListError", e);
        })
        .finally(() => {
          this.pointTableLoading = false;
        });
    },
    // 点位弹框 取消
    pointsModalhandleCancel() {
      this.$emit("update:visibleModal", false);
      this.$emit("reloadTags");
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 点位列表 重写全选
    onPointSelectAll(selected) {
      if (selected) {
        this.selectedRowKeys = this.pointList.map(item => item.id);
      } else {
        this.selectedRowKeys = [];
      }
    },
    //  批量删除点位确认框
    deletePointsConfirm() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning("请先选择点位！");
        return;
      }
      let _this = this;
      this.$confirm({
        title: "确认删除所选点位吗?",
        content: (
          <div style="color:rgba(0, 0, 0, 0.65);fontSize:14px">
            删除点位后，将不可恢复，请谨慎操作
          </div>
        ),
        onOk() {
          _this.deletePointsApi(_this.selectedRowKeys);
        },
        onCancel() {}
      });
    },
    deletePointsApi(pointIds) {
      if (!(Array.isArray(pointIds) && pointIds.length > 0)) return;
      api
        .deleteApi("/tag/tagPoint", {
          tagId: this.modalId,
          pointIds
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.getPointList();
          } else {
            this.$message.warning(res.data.msg || "删除失败");
          }
        })
        .catch(e => {
          console.error("deletePointsApiError", e);
        });
    },
    // 表格筛选
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    // 表格筛选重置
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .tag-ponit-modal {
  .ant-modal-body {
    position: relative;
  }
  .tag-point-table-bottom {
    position: absolute;
    bottom: 40px;
  }
  .row-btns {
    margin-bottom: 16px;
  }
}

/deep/ .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 12px 12px;
}
</style>
